<div class="custom-box" *ngIf="isDataAvailable()">
    <section class="blue-theme" *ngIf="color === 'pur'">
        <div class="col-lg-11  gst-section mb3  ">
            <div class="col-xs-12 col-md-6 col-lg-4 card solution_card ">
                <div class="gst-card-header lightblue">

                    <div *ngFor="let taxLeg of taxLegislationList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="taxLeg.contentType?.titleEn"
                            [textHi]="taxLeg.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class="ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let taxLeg of taxLegislationList">
                            <cbic-link [linkTextEn]="taxLeg.titleEn" [linkTextHi]="taxLeg.titleHi"
                                [linkEn]="taxLeg.path" [linkHi]="taxLeg.path"></cbic-link>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 card solution_card ">
                <div class="gst-card-header bg1">
                    <div *ngFor="let onlineService of onlineServiceList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="onlineService.contentType?.titleEn"
                            [textHi]="onlineService.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class="ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let onlineService of onlineServiceList">
                            <cbic-link [linkTextEn]="onlineService.titleEn" [linkTextHi]="onlineService.titleHi"
                                [linkEn]="onlineService.path" [linkHi]="onlineService.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 card margin-right-none solution_card">
                <div class="gst-card-header bg2">

                    <div *ngFor="let updateList of gstUpdatesList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="updateList.contentType?.titleEn"
                            [textHi]="updateList.contentType?.titleHi"></cbic-static-text>
                    </div>

                </div>
                <ul class="custom-scroll-bar">
                    <li *ngFor="let updateList of gstUpdatesList">
                        <cbic-link [linkTextEn]="updateList.titleEn" [linkTextHi]="updateList.titleHi"
                            [linkEn]="updateList.path" [linkHi]="updateList.path"></cbic-link>
                    </li>
                </ul>


            </div>
        </div>
        <!---first row ends here-->
        <!---second row start-->
        <div class="col-lg-11  gst-section">
            <div class="col-xs-12 col-md-6 col-lg-4 card solution_card ">
                <div class="gst-card-header lightblue">

                    <!-- <span class="text-heading">Manuals & FAQs</span> -->
                    <div *ngFor="let manualService of manualServiceList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="manualService.contentType?.titleEn"
                            [textHi]="manualService.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class="ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let manualService of manualServiceList">
                            <cbic-link [linkTextEn]="manualService.titleEn" [linkTextHi]="manualService.titleHi"
                                [linkEn]="manualService.path" [linkHi]="manualService.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 card solution_card ">
                <div class="gst-card-header bg1">

                    <div *ngFor="let rateService of gstRateServiceList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="rateService.contentType?.titleEn"
                            [textHi]="rateService.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class="ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let rateService of gstRateServiceList">
                            <cbic-link [linkTextEn]="rateService.titleEn" [linkTextHi]="rateService.titleHi"
                                [linkEn]="rateService.path" [linkHi]="rateService.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 card margin-right-none solution_card ">
                <div class="gst-card-header bg2">
                    <div *ngFor="let misService of miscellaneousServiceList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="misService.contentType?.titleEn"
                            [textHi]="misService.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class="ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let misService of miscellaneousServiceList">
                            <cbic-link [linkTextEn]="misService.titleEn" [linkTextHi]="misService.titleHi"
                                [linkEn]="misService.path" [linkHi]="misService.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
    <section class="gst-section-black" *ngIf="color === 'bule'">
        <div class="col-lg-11  gst-section mb3  ">
            <div class="col-xs-12 col-md-6 col-lg-4 card solution_card ">
                <div class="gst-card-header">
                    <div *ngFor="let taxLeg of taxLegislationList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="taxLeg.contentType?.titleEn"
                            [textHi]="taxLeg.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class="ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let taxLeg of taxLegislationList">
                            <cbic-link [linkTextEn]="taxLeg.titleEn" [linkTextHi]="taxLeg.titleHi"
                                [linkEn]="taxLeg.path" [linkHi]="taxLeg.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 card solution_card ">
                <div class="gst-card-header bg1">

                    <!-- <span class="text-heading">Online Services</span> -->
                    <div *ngFor="let onlineService of onlineServiceList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="onlineService.contentType?.titleEn"
                            [textHi]="onlineService.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class=" ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let onlineService of onlineServiceList">
                            <cbic-link [linkTextEn]="onlineService.titleEn" [linkTextHi]="onlineService.titleHi"
                                [linkEn]="onlineService.path" [linkHi]="onlineService.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 card margin-right-none solution_card">
                <div class="gst-card-header bg2">

                    <!-- <span class="text-heading">Updates</span> -->
                    <div *ngFor="let updateList of gstUpdatesList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="updateList.contentType?.titleEn"
                            [textHi]="updateList.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <ul class="custom-scroll-bar">
                    <li *ngFor="let updateList of gstUpdatesList">
                        <cbic-link [linkTextEn]="updateList.titleEn" [linkTextHi]="updateList.titleHi"
                            [linkEn]="updateList.path" [linkHi]="updateList.path"></cbic-link>
                    </li>
                </ul>


            </div>
        </div>
        <div class="col-lg-11  gst-section">
            <div class="col-xs-12 col-md-6 col-lg-4 card solution_card ">
                <div class="gst-card-header lightblue">
                    <div *ngFor="let manualService of manualServiceList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="manualService.contentType?.titleEn"
                            [textHi]="manualService.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class="ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let manualService of manualServiceList">
                            <cbic-link [linkTextEn]="manualService.titleEn" [linkTextHi]="manualService.titleHi"
                                [linkEn]="manualService.path" [linkHi]="manualService.path"></cbic-link>
                        </li>
                    </ul>
                </div>

            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 card solution_card ">
                <div class="gst-card-header bg1">
                    <div *ngFor="let rateService of gstRateServiceList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="rateService.contentType?.titleEn"
                            [textHi]="rateService.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <ul class="ellipsis custom-scroll-bar">
                    <span *ngIf="flag==='En'">
                        <ng-container *ngFor="let rateService of gstRateServiceList">
                            <ng-container *ngIf="rateService.titleEn==='Ready Reckoner for rates on Goods'">
                                <li>
                                    <cbic-link [linkTextEn]="rateService.titleEn" [linkEn]="rateService.path">
                                    </cbic-link>
                                </li>
                            </ng-container>
                        </ng-container>
                    </span>
                    <span *ngIf="flag==='Hi'">
                        <ng-container *ngFor="let rateService of gstRateServiceList">
                            <ng-container *ngIf="rateService.titleHi=='वस्तु मूल्य निर्धारण के लिए तत्काल परिकलक '">
                                <li>
                                    <cbic-link [linkTextHi]="rateService.titleHi" [linkHi]="rateService.path">
                                    </cbic-link>
                                </li>
                            </ng-container>
                        </ng-container>
                    </span>
                    <span *ngIf="flag==='En'">
                        <li>Consolidated Notifications</li>
                        <ul>
                            <ng-container *ngFor="let rateService of gstRateServiceList">
                                <ng-container *ngIf="rateService.titleEn!=='Ready Reckoner for rates on Goods'">
                                    <li>
                                        <cbic-link [linkTextEn]="rateService.titleEn" [linkEn]="rateService.path">
                                        </cbic-link>
                                    </li>
                                </ng-container>
                            </ng-container>
                        </ul>
                    </span>

                    <span *ngIf="flag==='Hi'">
                        <li>समेकित सूचनाएं</li>
                        <ul>
                            <ng-container *ngFor="let rateService of gstRateServiceList">
                                <ng-container
                                    *ngIf="rateService.titleHi!=='वस्तु मूल्य निर्धारण के लिए तत्काल परिकलक '">
                                    <li>
                                        <cbic-link [linkTextHi]="rateService.titleHi" [linkHi]="rateService.path">
                                        </cbic-link>
                                    </li>
                                </ng-container>
                            </ng-container>
                        </ul>
                    </span>
                </ul>

            </div>
            <div class="col-xs-12 col-md-6 col-lg-4 card margin-right-none solution_card ">
                <div class="gst-card-header bg2">
                    <div *ngFor="let misService of miscellaneousServiceList;let i = index">
                        <cbic-static-text *ngIf="i== 0" class="Header" [textEn]="misService.contentType?.titleEn"
                            [textHi]="misService.contentType?.titleHi"></cbic-static-text>
                    </div>
                </div>
                <div class="ellipsis custom-scroll-bar">
                    <ul>
                        <li *ngFor="let misService of miscellaneousServiceList">
                            <cbic-link [linkTextEn]="misService.titleEn" [linkTextHi]="misService.titleHi"
                                [linkEn]="misService.path" [linkHi]="misService.path"></cbic-link>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </section>
</div>